<template>

    <v-modal title="Request Feature">
        <template #body>
            <v-alert :message="error" />
            <v-form-group dir="ver" label="Subject">
                <v-select :model="params.subject" @input="params.subject = $event">
                    <option v-for="subject in subjects" :value="subject" :key="subject">{{ subject }}</option>
                </v-select>
            </v-form-group>
            <v-form-group dir="ver" label="Message">
                <v-textarea placeholder="Your message..." :model="params.note" @input="params.note = $event" />
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="send">Send</v-button>
        </template>
    </v-modal>

</template>

<script>

import UserApi from '@api/UserApi';

export default {

    data() {
        return {
            loading: false,
            error: null,
            subjects: [
                'Feature Request',
                'Integration Request',
                'Technical Question',
                'Bug Report',
            ],
            params: {},
        }
    },

    created() {
        this.params.subject = this.subjects[0];
    },

    methods: {

        send() {
            this.loading = true;
            UserApi.sendFeedback(this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.sent'));
                    this.$store.commit('showModal', false);
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    }

}

</script>
